import {Component, forwardRef, Input} from '@angular/core';
import {ConnectionType, ConnectionValue} from "@flowmaps/flowmaps-typescriptmodels";
import {NG_VALUE_ACCESSOR} from "@angular/forms";
import {AbstractValueAccessorComponent} from "../../../../common/component/value-accessor.component";
import {sendQuery} from "../../../../common/app-common-utils";

@Component({
  selector: 'app-connection-value-select',
  templateUrl: './connection-value-select.component.html',
  styleUrls: ['./connection-value-select.component.scss'],
  providers: [
    {provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => ConnectionValueSelectComponent), multi: true}
  ]
})
export class ConnectionValueSelectComponent extends AbstractValueAccessorComponent<ConnectionValue> {
  @Input() type: ConnectionType | string;
  @Input() required: boolean;
  @Input() disabled: boolean;

  private _value: ConnectionValue;

  get value(): ConnectionValue {
    return this._value;
  }

  set value(value: ConnectionValue) {
    this.writeValue(value);
  }

  writeValue(value: ConnectionValue): void {
    this._value = value;
    this.onModelChange();
  }

  getConnectionValues = () => sendQuery("getConnectionValues", this.type as ConnectionType);

  connectionValueFormatter = (value: ConnectionValue) => value ? `${value.name}` : null;
}
